import {
  InteractionRequiredAuthError,
  InteractionStatus,
} from "@azure/msal-browser"
import { loginRequest, msalConfig } from "./authConfig"
import DebugLogger from "../Common/Debug"

let configuredAuthorityHost = ""
try {
  configuredAuthorityHost = new URL(msalConfig.auth.authority).host
} catch {
  configuredAuthorityHost = ""
}

/**
 * Callers pass the `accounts` array from useMsal, and a few still pass a
 * single AccountInfo. acquireTokenSilent needs one AccountInfo whose
 * environment matches the configured authority.
 */
export function resolveMsalAccount(accounts) {
  const candidates = (Array.isArray(accounts) ? accounts : [accounts]).filter(
    Boolean
  )

  return (
    candidates.find(
      candidate => candidate.environment === configuredAuthorityHost
    ) || candidates[0]
  )
}

export const authToken = async (accounts, inProgress, instance) => {
  const account = resolveMsalAccount(accounts)
  if (!account || inProgress !== InteractionStatus.None) {
    return ""
  }

  try {
    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    })
    return response.accessToken
  } catch (error) {
    // Redirecting on any other failure (authority mismatch, bad account)
    // restarts login on every page load and never terminates.
    if (error instanceof InteractionRequiredAuthError) {
      DebugLogger(
        "AuthToken",
        "Silent token acquisition fails. Acquiring token using redirect" +
          error
      )
      return instance.acquireTokenRedirect(loginRequest)
    }

    console.error(
      "Access token unavailable and interaction cannot fix it:",
      error
    )
    return ""
  }
}
